import { createContext, useContext } from 'react';
const initialState = {
  getCountryAddressForm: () => undefined,
  addressTemplates: undefined
};
export const AddressFormsContext = /*#__PURE__*/createContext(initialState);
export const getAddressForm = (templates, country) => {
  var _templates$find, _templates$find2;
  return (templates == null || (_templates$find = templates.find(template => template.country === country)) == null ? void 0 : _templates$find.template) || (templates == null || (_templates$find2 = templates.find(template => template.country === 'COMMON')) == null ? void 0 : _templates$find2.template);
};
export function useAddressForms() {
  const context = useContext(AddressFormsContext);
  if (context === undefined) {
    throw new Error('useAddressForms must be used within a AddressFormsContext');
  }
  return context;
}
//# sourceMappingURL=address-forms-context.js.map